// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/inquiry.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/inquiry.proto.
 */
export const file_v1_inquiry: GenFile = /*@__PURE__*/
  fileDesc("ChB2MS9pbnF1aXJ5LnByb3RvEgJ2MSLIAQoSU2VuZElucXVpcnlSZXF1ZXN0EhIKCm1lc3NhZ2VfaWQYASABKAMSFwoPaW5xdWlyeV9jb250ZW50GAIgASgJEhQKDGNvbnRhY3RfaW5mbxgDIAEoCRIOCgZzb3VyY2UYBCABKAkSDwoHY29udGV4dBgFIAEoCRITCgtjdXN0b21lcl9pZBgGIAEoBRIOCgZyZWdpb24YByABKAkSKQoOY2FsY3VsYXRlX2RhdGUYCCABKAsyES5nb29nbGUudHlwZS5EYXRlIjcKE1NlbmRJbnF1aXJ5UmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJMlIKDklucXVpcnlTZXJ2aWNlEkAKC1NlbmRJbnF1aXJ5EhYudjEuU2VuZElucXVpcnlSZXF1ZXN0GhcudjEuU2VuZElucXVpcnlSZXNwb25zZSIAQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_type_date]);

/**
 * @generated from message v1.SendInquiryRequest
 */
export type SendInquiryRequest = Message<"v1.SendInquiryRequest"> & {
  /**
   * @generated from field: int64 message_id = 1;
   */
  messageId: bigint;

  /**
   * @generated from field: string inquiry_content = 2;
   */
  inquiryContent: string;

  /**
   * @generated from field: string contact_info = 3;
   */
  contactInfo: string;

  /**
   * source names the screen the report was sent from (e.g. "bet_limit").
   * Empty for the general inquiry page.
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * context is what the user was looking at when reporting, such as the
   * filters and the result shown. Kept apart from the user's own text.
   *
   * @generated from field: string context = 5;
   */
  context: string;

  /**
   * customer_id, region and calculate_date identify the Dư chuẩn view being
   * reported. Read only when source is "bet_limit".
   *
   * @generated from field: int32 customer_id = 6;
   */
  customerId: number;

  /**
   * @generated from field: string region = 7;
   */
  region: string;

  /**
   * @generated from field: google.type.Date calculate_date = 8;
   */
  calculateDate?: Date;
};

/**
 * Describes the message v1.SendInquiryRequest.
 * Use `create(SendInquiryRequestSchema)` to create a new message.
 */
export const SendInquiryRequestSchema: GenMessage<SendInquiryRequest> = /*@__PURE__*/
  messageDesc(file_v1_inquiry, 0);

/**
 * @generated from message v1.SendInquiryResponse
 */
export type SendInquiryResponse = Message<"v1.SendInquiryResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.SendInquiryResponse.
 * Use `create(SendInquiryResponseSchema)` to create a new message.
 */
export const SendInquiryResponseSchema: GenMessage<SendInquiryResponse> = /*@__PURE__*/
  messageDesc(file_v1_inquiry, 1);

/**
 * @generated from service v1.InquiryService
 */
export const InquiryService: GenService<{
  /**
   * @generated from rpc v1.InquiryService.SendInquiry
   */
  sendInquiry: {
    methodKind: "unary";
    input: typeof SendInquiryRequestSchema;
    output: typeof SendInquiryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_inquiry, 0);

